/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusNewsletterContentDto } from '../../models/lexplus-newsletter-content-dto';

export interface NewsletterControllerFindContentV1$Params {
  id: string;
}

export function newsletterControllerFindContentV1(http: HttpClient, rootUrl: string, params: NewsletterControllerFindContentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusNewsletterContentDto>> {
  const rb = new RequestBuilder(rootUrl, newsletterControllerFindContentV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusNewsletterContentDto>;
    })
  );
}

newsletterControllerFindContentV1.PATH = '/v1/newsletter/{id}/inhalt';
